import React, { useRef, useState } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, mediaUrl, formatApiError } from "@/lib/api";

interface Props {
  value?: string | null;
  onChange: (url: string | null) => void;
  testid?: string;
}

export const ImageUploader: React.FC<Props> = ({ value, onChange, testid = "image-uploader" }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [loading, setLoading] = useState(false);

  const handleFile = async (file: File) => {
    setLoading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/admin/media", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
      toast.success("Immagine caricata");
    } catch (err: any) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid={testid}>
      {value ? (
        <div className="relative inline-block group">
          <img
            src={mediaUrl(value)}
            alt=""
            className="h-28 w-28 object-cover border border-white/15"
          />
          <button
            type="button"
            data-testid={`${testid}-remove`}
            onClick={() => onChange(null)}
            className="absolute -top-2 -right-2 bg-destructive text-white p-1 hover:scale-110 transition-transform"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      ) : (
        <button
          type="button"
          data-testid={`${testid}-button`}
          onClick={() => inputRef.current?.click()}
          disabled={loading}
          className="h-28 w-28 border border-dashed border-white/25 flex flex-col items-center justify-center gap-2 text-muted-foreground hover:border-primary hover:text-primary transition-colors"
        >
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Upload className="h-5 w-5" />}
          <span className="text-[10px] uppercase tracking-wider">Carica</span>
        </button>
      )}
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/jpg,image/png,image/webp"
        className="hidden"
        onChange={(e) => {
          const f = e.target.files?.[0];
          if (f) handleFile(f);
          e.target.value = "";
        }}
      />
    </div>
  );
};
